import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarCodigosBarrasProdutos(api, parametros) {
    parametros.operacao = 'buscarCodigosBarrasProdutos';

    let retorno = {};

    await api.santriPOST('/rest/produto', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RProduto/RProdutoBuscarCodigosBarrasProdutos.js